import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GlobalHelmet } from './components/MoiPayHelmet';
import Navbar from './components/Navbar';
import Footer from './components/footer/Footer';
import Home from './screens/Home';
import About from './screens/About';
import Blog from './screens/Blog';
import Team from './screens/Team';
import Contact from './screens/Contact';
import Terms from './screens/Terms';
import Privacy from './screens/Privacy';
import './App.css';

function App() {
  return (
    <Router>
      <GlobalHelmet />
      <div className=" w-full min-h-screen bg-[rgba(18,18,18,1)] flex flex-col overflow-x-hidden">
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/Blog" element={<Blog />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
